import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";
export const getEventItemDetail = async (eventEditId, eventItemIds) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}events/${eventEditId}/item/${eventItemIds}`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default getEventItemDetail;
